import { CommonModule } from "@angular/common"
import { NgModule } from "@angular/core"
import { FormsModule } from "@angular/forms"
import { MatButtonModule } from "@angular/material/button"
import { MatExpansionModule } from "@angular/material/expansion"
import { MatListModule } from "@angular/material/list"
import { MatSidenavModule } from "@angular/material/sidenav"
import { MatToolbarModule } from "@angular/material/toolbar"
import { MatTooltipModule } from "@angular/material/tooltip"
import { RouterModule } from "@angular/router"
import { EmptyLayoutComponent } from "./empty/empty-layout.component"
import { FooterModule } from "./footer/footer.module"
import { LoggedInLayoutComponent } from "./logged-in/logged-in-layout.component"
import { MatMenuModule } from "@angular/material/menu"

const COMPONENTS = [
  LoggedInLayoutComponent,
  EmptyLayoutComponent,
]

@NgModule({
  declarations: COMPONENTS,
  exports: COMPONENTS,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatSidenavModule,
    MatListModule,
    MatExpansionModule,
    MatMenuModule,
    MatToolbarModule,
    MatButtonModule,
    MatTooltipModule,
    FooterModule,
  ]
})
export class LayoutModule { }
